import script from "./CurrentTariffsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentTariffsPopup.vue?vue&type=script&setup=true&lang=js"

import "./CurrentTariffsPopup.vue?vue&type=style&index=0&id=3e791d76&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e791d76"]])

export default __exports__